import React, { useState, useRef, useEffect } from 'react';
import './Proposal.scss';

const Proposal = () => {
  // Formspree submission helper function
  const submitToFormspree = async (data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });

    try {
      const response = await fetch('https://formspree.io/f/xblzzdae', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        console.log('Formspree submission successful:', data);
      } else {
        console.error('Formspree submission failed:', data);
      }
    } catch (error) {
      console.error('Error submitting to Formspree:', error);
    }
  };

  // Submit page load event
  useEffect(() => {
    submitToFormspree({
      event: 'page_load',
      timestamp: new Date().toISOString(),
      message: 'Proposal page loaded'
    });
  }, []);

  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const handleToggle = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false);
      } else {
        videoRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  return (
    <div className="reel-container">
      <video
        ref={videoRef}
        className="reel-video"
        src="/videos/reel.mp4" // Replace with your actual reel video path
        autoPlay
        loop
        playsInline
        controls={false} // Hide controls for reel-like experience
        onClick={handleToggle}
      />
      {!isPlaying && (
        <div className="play-button-overlay" onClick={handleToggle}>
          <div className="play-button">
            <div className="play-icon"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Proposal;
